import L, { LatLngExpression } from "leaflet";

const iconBaseUrl = "/static/frontend/icons/";
const baseIcon: L.IconOptions = {
  iconUrl: `${iconBaseUrl}marker-icon.svg`,
  shadowUrl: `${iconBaseUrl}marker-shadow.svg`,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41],
};

const hotelIcon = L.icon({
  ...baseIcon,
  iconUrl: `${iconBaseUrl}marker-icon-hotel.svg`,
});

const partyIcon = L.icon({
  ...baseIcon,
  iconUrl: `${iconBaseUrl}marker-icon-party.svg`,
});

const walkingIcon = L.icon({
  iconUrl: `${iconBaseUrl}walking.svg`,
  iconSize: [25, 41],
  iconAnchor: [0, 24],
  popupAnchor: [1, -34],
});

class LocationMap extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {
    // Create map container
    const mapContainerId = "locationMapId";
    const mapContainer = document.createElement("div");
    mapContainer.id = mapContainerId;
    mapContainer.style.height = "420px";
    mapContainer.style.width = "90%";
    mapContainer.style.margin = "0 auto";
    this.append(mapContainer);

    const map = L.map(mapContainerId, {
      center: [47.80102, 11.83425],
      zoom: 15,
    });

    // Acutal map tile
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      referrerPolicy: "strict-origin-when-cross-origin",
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    // Hotel marker
    L.marker([47.795874, 11.838434], { title: "Hotel", icon: hotelIcon })
      .bindTooltip("Hotel").openTooltip()
      .addTo(map);

    // Event location marker
    L.marker([47.80578, 11.82670], { title: "Event location", icon: partyIcon })
      .bindTooltip("Event Location").openTooltip()
      .addTo(map);

    // Walking markers
    L.marker([47.798108, 11.832093], { title: "Foot path", icon: walkingIcon })
      .addTo(map);
    L.marker([47.801625, 11.827608], { title: "Foot path", icon: walkingIcon })
      .addTo(map);

    // Foot path
    const latlngs: LatLngExpression[] = [
      [47.795406, 11.837758],
      [47.795543, 11.836771],
      [47.797640, 11.832361],
      [47.798108, 11.832093],
      [47.798108, 11.831224],
      [47.798418, 11.830462],
      [47.799968, 11.829507],
      [47.799896, 11.828606],
      [47.801625, 11.827608],
      [47.803585, 11.827565],
      [47.804263, 11.826986],
      [47.805690, 11.826857],
    ];

    L.polyline(latlngs, { color: "green" })
      .bindTooltip("Andando").openTooltip()
      .addTo(map);
  }
}

customElements.define("location-map", LocationMap);
